module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-8 col-md-12"
  }, [_c('form', {
    staticClass: "float-left"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTypeField),
      expression: "newTypeField"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "id": "visaTypeName",
      "placeholder": "Create new visa type"
    },
    domProps: {
      "value": (_vm.newTypeField)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newTypeField = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary input-group-btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.addType
    }
  }, [_c('i', {
    staticClass: "icon icon-plus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn input-group-btn",
    staticStyle: {
      "color": "#136efb",
      "border-color": "#136efb"
    },
    on: {
      "click": _vm.importType
    }
  }, [_c('i', {
    staticClass: "icon icon-upload"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-8 col-md-12"
  }, _vm._l((_vm.visatypes), function(type, index) {
    return _c('div', [_c('div', {
      staticClass: "visatype"
    }, [_c('h3', [_c('a', {
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.editType(type)
        }
      }
    }, [_vm._v(_vm._s(type.name))])]), _vm._v(" "), _c('div', {
      staticClass: "tile-action"
    }, [_c('button', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.editType(type)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.exportType(type)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.delType(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])])
  }), 0)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b0a2989e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/visatypes.vue
// module id = 517
// module chunks = 1